export enum NODE_TYPE {
  GROUP = 'usersGroupNode',
  EMPTY = 'emptyNode',
}
